import { Modal, Spin } from 'antd'
// Path casing must match the file on disk (usePWAupdate.js) — a case-insensitive
// dev filesystem hides the mismatch, but a Linux/CI build would fail to resolve it.
import { usePWAUpdate } from '../hooks/usePWAupdate'
import { useEffect } from 'react'

const UpdateNotification = () => {
  const { updateAvailable, updateApp } = usePWAUpdate()

  useEffect(() => {
    if (updateAvailable) {
      // Auto-update without user interaction
      updateApp()
      // Small delay to ensure service worker update is registered
      setTimeout(() => {
        window.location.reload()
      }, 500)
    }
  }, [updateAvailable, updateApp])

  return (
    <Modal
      open={updateAvailable}
      footer={null}
      closable={false}
      centered
      maskClosable={false}
    >
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <Spin size="large" />
        <p style={{ marginTop: '20px', fontSize: '16px', fontWeight: 500 }}>
          A new version of Tanaka Life is available. Please wait whilst we update ...
        </p>
      </div>
    </Modal>
  )
}

export default UpdateNotification
